module.exports = __webpack_public_path__ + "fc5.jpg";